import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { HttpErrorService } from '../../services/http-error.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromAppDataActions from './app-config.actions';
import { SharedConfigWrapper } from '../../models/app-config/shared-config-wrapper';
import { plainToInstance } from 'class-transformer';

@Injectable()
export class AppConfigEffects {
  fetchAppConfigData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromAppDataActions.fetchAppConfigData),
      switchMap(() => {
        return this.http.get<unknown>('assets/config/config.json').pipe(
          map((json: unknown) => {
            const appConfigData = plainToInstance(SharedConfigWrapper, json);
            return fromAppDataActions.setAppConfigData({ payload: appConfigData });
          }),
          catchError((error) => {
            return this.httpErrorService.handleError(
              'App data',
              fromAppDataActions.fetchAppConfigData,
              fromAppDataActions,
              error,
            );
          }),
        );
      }),
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly httpErrorService: HttpErrorService,
  ) {}
}
